import type { IntegrationFactory } from './factory';
export const yandexMetrikaFactory: IntegrationFactory = async (config, global, ctx) => {
  const counterId = config.getOrThrow('YANDEX_METRIKA_COUNTER_ID') as unknown as string;
  const { YandexMetrika } = await import('@cp/shared/tracking/integrations/yandexMetrika');
  return new YandexMetrika(
    {
      counterId,
    },
    global,
    ctx,
  );
};
